



















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class Session extends Vue {
  @Prop(Object)
  private session: object = {};
}
